
<!-- Page 4 - Node Main -->

<template>
  <div class="page3 animated fadeIn">
    <img class="paddle" src="media/global/paddle.png"/>
    <div class="main-info">
      <h3 class="main-title">{{items.page4.title}}</h3>
      <p class="main-text" v-html="items.page4.text"></p>
    </div>

    <!-- Node Holder Section -->
    <div class="node-holder">
      <div v-for="(item, index) in (this.path)"
           @click="nodeRouter(item, index)"
           v-show="!detailsViewMode || detailsViewMode && selectedNode === item.nodeID"
           :class="{selected: detailsViewMode && selectedNode === item.nodeID}">


          <div class="each-node">
            <img :src="item.nodeIcon"/>
            <div class="text-holder">
              <p>{{item.nodeTitle}}</p>
            </div>
            <img class="checkmark" src="media/page4/checkmark.png"
            v-show="state.completedNodes[index]"/>
          </div>

      </div>

      </div>

    <!-- Detail Section -->
    <transition
      name="detail-transition"
      enter-active-class="animated fadeIn">
      <div class="detail-holder" v-show="detailsViewMode === true">
        <p>{{this.selectedNodePath.detailText}}</p>
        <div class="detail-continue"
             @click="continueRouter()">
          <img src="media/global/btn_continue.png"/>
          <p>{{items.globalButtons.continueButton}}</p>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>

export default {
  data() {
    return {
      selectedNode: 1,
      detailsViewMode: false
    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    state() {
      return this.$store.state
    },
    items() {
      return this.$store.state.items
    },
    path() {
      return this.$store.state.items.page4.nodes
    },
    selectedNodePath() {
      return this.items.page4.nodes[(this.selectedNode-1)]
    },
    completedNodes() {
      return this.$store.state.completedNodes
    }
  },
  methods: {
    nodeRouter(item, index) {
      this.selectedNode = item.nodeID;
      this.detailsViewMode = true;
      this.state.completedNodes[index] = true;
    },
    showExit () {
      function isComplete(el) {
        return (el === true);
      }
       if (this.completedNodes.every(isComplete) && !this.detailsViewMode) {
         this.$store.commit('contTrue');
       }
    },
    continueRouter() {
      this.detailsViewMode = false;
      this.selectedNode = 1;
      this.showExit()
    },
    exit() {
      console.log('TRAINING CONCLUDED. EXIT.') //^* Need to write exit function
    },
    checkCue() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      // var self = this
      // if(Math.floor(self.$refs.audio1.currentTime) == 3){
      //   self.vis1 = "visible"
      // }
    },
    runInterval() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      this.interval = setInterval(this.checkCue, 100)
    }
  },
  mounted() {
    //JIRA LOCATION
    this.$store.commit("scormLMS/changeUserLocation", "MA KPIs: Page 3");
    this.$store.commit('contFalse');
    this.showExit()

  },
  beforeDestroy() {
    //BOILERPLATE FOR RUNNING AN INTERVAL
    clearInterval(this.interval);
  },
  components: {},
  props: []
};
</script>

<style scoped>
.node-holder {
  position: absolute;
  z-index: 500;
  width: 825px;
  display: flex;
  justify-content: space-around;
  margin-top: 200px;
  margin-left: 95px;
}
.each-node {
  cursor: pointer;
  position: relative;
  -webkit-filter: drop-shadow(3px 3px 5px #aaa );
  filter: drop-shadow(3px 3px 5px #aaa);
}
.each-node img {
  width: auto;
}
.text-holder {
  position: absolute;
  top: 0;
  margin-top: 117px;
  margin-left: 6px;
  width: 105px;
  height: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.each-node p {
  font-size: 13px;
  line-height: 1.1;
  font-family: 'Nunito', sans-serif;
  color: white;
  text-align: center;
}
.each-node .checkmark {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 3px;
  margin-right: -1px;
  width: auto;
}
.selected {
  margin-left: -225px;
}
.detail-holder {
  position: absolute;
  right: 0;
  width: 430px;
  height: 225px;
  z-index: 900;
  margin-top: 185px;
  margin-right: 55px;
}
.detail-continue {
  position: absolute;
  right: 0;
  bottom: -18px;
  cursor: pointer;
  -webkit-filter: drop-shadow(1.5px 1.5px 1px #222);
  filter: drop-shadow(1.5px 1.5px 1px #222);
}
.detail-continue p {
  margin-top: -22px;
  margin-left: 9px;
  font-size: 14px;
}
.button-exit {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 990;
  cursor: pointer;
  user-select: none;
  -webkit-filter: drop-shadow(1.5px 1.5px 1px #222 );
  filter: drop-shadow(1.5px 1.5px 1px #222);
}
.button-title {
  position: absolute;
  bottom: 4px;
  right: 40px;
  z-index: 999;
  font-size: 13px;
  text-decoration: none;
  color: black;
  font-family: 'Nunito',sans-serif;
}
@media only screen and (max-width: 737px) {

  .node-holder {
    width: 647px;
    margin-top: 130px;
    margin-left: 6px;
    margin-right: 6px;
  }
  .each-node img {
    width: 102px;
  }
  .text-holder {
    margin-top: 47px;
    margin-left: 0;
    width: 102px;
    height: 100%;
  }
  .each-node p {
    font-size: 11px;
    line-height: 1.1;
    text-align: center;
  }
  .each-node .checkmark {
    margin-right: 1px;
  }
  .selected {
    margin-left: -540px;
  }
  .detail-holder {
    width: 515px;
    height: 185px;
    margin-top: 110px;
    margin-right: 10px;
  }
  .detail-continue {
    position: absolute;
    right: 0;
    bottom: -18px;
    cursor: pointer;
    -webkit-filter: drop-shadow(1.5px 1.5px 1px #222);
    filter: drop-shadow(1.5px 1.5px 1px #222);
  }
  .detail-continue p {
    margin-top: -22px;
    margin-left: 9px;
    font-size: 14px;
  }

}

</style>



// WEBPACK FOOTER //
// Page3.vue?1717cf39